import { ApplicationRef, inject, Injectable, Renderer2, RendererFactory2 } from '@angular/core';

/** Enum representing all the themes. Define these themes in the theme/ folder.
 * Use the class name of the theme as the value of the Theme enum
 */
export enum Theme {
  Sparket = 'sparket',
}

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  private renderer: Renderer2;
  private appRef = inject(ApplicationRef);

  constructor(rendererFactory: RendererFactory2) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  public initialise(): void {
    this.applyTheme(Theme.Sparket);
  }

  private applyTheme(theme: Theme): void {
    const body = document.body;
    this.removeThemes();
    this.renderer.addClass(body, theme);
    this.appRef.tick();
  }

  private removeThemes(): void {
    const body = document.body;
    const themes = Object.values(Theme);
    themes.forEach((theme) => {
      this.renderer.removeClass(body, theme);
    });
  }
}
